import React from 'react';
import { Switch } from 'react-router-dom';

import Route from './Route';

import Home from '~/pages/Home';

import Login from '~/pages/Login';
import Signup from '~/pages/Signup';
import RecoverPassword from '~/pages/RecoverPassword';
import ChangePassword from '~/pages/ChangePassword';
import ActivateAccount from '~/pages/ActivateAccount';
import Profile from '~/pages/Profile';
import SearchEvents from '~/pages/SearchEvents';
import Event from '~/pages/Event';
import CheckoutCategories from '~/pages/CheckoutCategories';
import CheckoutOwnership from '~/pages/CheckoutOwnership';
import CheckoutPayment from '~/pages/CheckoutPayment';
import MyTickets from '~/pages/MyTickets';
import Ticket from '~/pages/Ticket';
import PersonalData from '~/pages/PersonalData';
import NotFound from '~/pages/NotFound';
import AutoLogin from '~/pages/AutoLogin';

const routes: React.FC = () => {
  return (
    <Switch>
      <Route path={`${process.env.PUBLIC_URL}/`} exact component={Home} both />

      <Route
        path={`${process.env.PUBLIC_URL}/auto-login/:token`}
        exact
        component={AutoLogin}
        both
      />

      <Route path={`${process.env.PUBLIC_URL}/login`} component={Login} />
      <Route
        path={`${process.env.PUBLIC_URL}/cadastro`}
        exact
        component={Signup}
      />
      <Route
        path={`${process.env.PUBLIC_URL}/perfil`}
        component={Profile}
        isPrivate
        exact
      />
      <Route
        path={`${process.env.PUBLIC_URL}/perfil/:slug`}
        component={Profile}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/cadastro/:slug`}
        component={Signup}
      />
      <Route
        path={`${process.env.PUBLIC_URL}/recuperar-senha`}
        component={RecoverPassword}
      />
      <Route
        path={`${process.env.PUBLIC_URL}/alterar-senha/:token`}
        component={ChangePassword}
      />
      <Route
        path={`${process.env.PUBLIC_URL}/ativar-conta/:token`}
        component={ActivateAccount}
      />

      <Route
        path={`${process.env.PUBLIC_URL}/meus-ingressos/proximos`}
        exact
        component={MyTickets}
        isPrivate
      />

      <Route
        path={`${process.env.PUBLIC_URL}/meus-ingressos/realizados`}
        exact
        component={MyTickets}
        isPrivate
      />

      <Route
        path={`${process.env.PUBLIC_URL}/meus-ingressos/devolvidos`}
        exact
        component={MyTickets}
        isPrivate
      />

      <Route
        path={`${process.env.PUBLIC_URL}/meus-ingressos/:status/:slug`}
        component={Ticket}
        isPrivate
      />

      <Route
        path={`${process.env.PUBLIC_URL}/buscar-eventos`}
        component={SearchEvents}
        both
      />

      <Route
        path={`${process.env.PUBLIC_URL}/eventos/:slug`}
        component={Event}
        exact
        both
      />

      <Route
        path={`${process.env.PUBLIC_URL}/evento/:slug`}
        component={Event}
        exact
        both
      />

      <Route
        path={`${process.env.PUBLIC_URL}/eventos/:slug/categorias`}
        component={CheckoutCategories}
        exact
        both
      />
      <Route
        path={`${process.env.PUBLIC_URL}/eventos/:slug/categorias/:preview`}
        component={CheckoutCategories}
        exact
        both
      />
      <Route
        path={`${process.env.PUBLIC_URL}/eventos/:slug/titularidade`}
        component={CheckoutOwnership}
        exact
        isPrivate
      />

      <Route
        path={`${process.env.PUBLIC_URL}/eventos/:slug/titularidade/:preview`}
        component={CheckoutOwnership}
        exact
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/eventos/:slug/resumo`}
        component={CheckoutPayment}
        exact
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/eventos/:slug/resumo/:preview`}
        component={CheckoutPayment}
        exact
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/eventos/:slug/dados-pessoais`}
        component={PersonalData}
        exact
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/eventos/:slug/:preview`}
        component={Event}
        exact
        both
      />
      <Route
        path={`${process.env.PUBLIC_URL}/pagina-nao-encontrada`}
        component={NotFound}
      />
      <Route path="*" component={NotFound} />
    </Switch>
  );
};

export default routes;
